import * as React from 'react';
import { IconButton } from '@mui/material';
import { Close as IconClose } from '@mui/icons-material';
import { useSnackbar, SnackbarKey } from 'notistack';


const SnackbarCloseButton = (props: any) => {
  
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton style={{color: "#fff" }}  onClick={() => closeSnackbar(props.id)}>
      <IconClose />
    </IconButton>
  );

}

export default SnackbarCloseButton;